import "./index.css";
import { useEffect, useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DashboardCounter from "../../components/DashboardCounter/index";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import moment from "moment";
import Form from "react-bootstrap/Form";
import PageLayout from "../../layouts/PageLayout";
import Ico1 from "../../assets/img/edit.png";
import Ico2 from "../../assets/img/delete.png";
import Ico3 from "../../assets/img/s.png";
import Ico4 from "../../assets/img/d.png";
import Clap from "../../assets/img/clap.png";
import Diconetwo from "../../assets/img/real_time.svg";
import Diconethree from "../../assets/img/active_daily_mgmt.svg";
import Iconone from "../../assets/img/beds.png";
import Icontwo from "../../assets/img/compliance.png";
import Iconthree from "../../assets/img/variance.png";
import Iconfour from "../../assets/img/hpuoc.png";
import Ico22 from "../../assets/img/info.png";
import Ico33 from "../../assets/img/warning.png";
import Ico44 from "../../assets/img/critical.png";
import { get, isEmpty } from "lodash";
import { API_CALL_URL_PRIVATE } from "../../constants";
import axios from "../../axios";
import { DOMAIN_URL } from "../../constants/compensate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactPaginate from "react-paginate";
import { setLoadingPage } from "../../store/actions";
import { flushSync } from "react-dom";
import AscIcon from "../../assets/img/desc.png";
import DescIcon from "../../assets/img/asc.png";
import { CiCalendarDate } from "react-icons/ci";
import ReactDatePicker from "react-datepicker";
import MultiSelect from "../../components/MultiSelectCustom/MultiSelectActivity";
import { ThemeContext } from "../../providers/ThemeProvider";
import Swal from "sweetalert2";
import Overlay from "../../components/Overlay";
import { CiShare1 } from "react-icons/ci";
import IntervalDetail from "../../components/RealtimeShiftModal/IntervalDetail";

function DirectData(props) {
  const dispatch = useDispatch();
  const [theme, setTheme] = useContext(ThemeContext);
  const userData = JSON.parse(localStorage.getItem("psAdmin"));
  const currentDate = new Date();
  const twoYearsAgo = moment().subtract(2, "years").toDate();
  const customer_code = useSelector((state) => state.compensate.customerCode);
  const loading_page = useSelector((state) => state.compensate.LoadingPage);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [dropCostCenterMaster, setDropCostCenterMaster] = useState([]);
  const [costCenterName, setCostCenterName] = useState([]);
  const [costCenterMaster, setCostCenterMaster] = useState(null);
  const [dashboardData, setDashboardData] = useState([]);
  const [customerData, setCustomerData] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [pageLimit, setPageLimit] = useState(50);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [hasPrev, setHasPrev] = useState(false);
  const [hasNext, setHasNext] = useState(false);
  const [sortKey, setSortKey] = useState("");
  const [isInitialData, setISInitialData] = useState(false);
  const [sortOrder, setSortOrder] = useState(1);
  const [searchTempKeyword, setSearchTempKeyword] = useState("");
  const boxdata = props.data;
  const isLoader = props.isLoader;
  const { issearch } = props;
  const [userDatas, setUserDatas] = useState(get(userData, "data", []));
  const [pageCounter, setPageCounter] = useState("");
  const [listLoader, setListLoader] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [errors, setErrors] = useState({
    dateFrom: "",
    dateTo: "",
    costCenterName: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showupdate, setShowupdate] = useState({
    state: false,
    shiftData: null,
  });

  const validateFields = () => {
    let newErrors = { dateFrom: "", dateTo: "", costCenterName: "" };
    let isValid = true;

    if (!dateFrom) {
      newErrors.dateFrom = "From Date is required.";
      isValid = false;
    }
    if (!dateTo) {
      newErrors.dateTo = "To Date is required.";
      isValid = false;
    }
    if (costCenterName.length === 0) {
      newErrors.costCenterName = "Cost Center is required ";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const preserveScrollPosition = (listboxId) => {
    const menuList = document.querySelector(listboxId);
    if (menuList) {
      const scrollTop = menuList.scrollTop; // Store scroll position
      setTimeout(() => {
        document.querySelector(listboxId)?.scrollTo(0, scrollTop);
      }, 0);
    }
  };

  function getDate(inputDate) {
    const timeZone = "America/Los_Angeles";
    const date = new Date(inputDate).toLocaleString("en-US", {
      timeZone,
      hour12: true,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });

    return date;
  }

  const renderElements = () => {
    return Array.from({ length: totalPages }, (_, index) => (
      <span
        key={index + 1}
        className={
          index + 1 === currentPage
            ? "paginate_button current"
            : "paginate_button"
        }
        aria-controls="example"
        role="link"
        aria-current="page"
        data-dt-idx="0"
        tabindex="0"
        onClick={() => {
          setCurrentPage(index + 1);
        }}
      >
        {index + 1}
      </span>
    ));
  };

  useEffect(() => {
    const getCustomerDetailList = async () => {
      try {
        const resp = await axios.post(`${API_CALL_URL_PRIVATE}/direct/list`, {
          customer_code: customer_code,
          searchKeyword: searchKeyword,
          limit: pageLimit,
          page: searchActive ? 1 : currentPage,
          sort_column: searchActive ? "" : sortKey,
          sort_order: searchActive ? 1 : sortOrder,
          start_date: dateFrom ? moment(dateFrom).format("DD-MM-YYYY") : "",
          end_date: dateTo ? moment(dateTo).format("DD-MM-YYYY") : "",
          cost_center_number_arr: costCenterName.map((e) => e.value),
        });
        console.log(resp, "resp");
        const Data = resp?.data?.data?.data;
        setSearchActive(false);
        setCustomerData(Data);
        setPageLimit(Data?.limit);
        setTotalPages(Data?.totalPages);
        setCurrentPage(Data?.page);
        setHasNext(Data?.hasNextPage);
        setHasPrev(Data?.hasPrevPage);
        setPageCounter(Data?.pagingCounter);
        setListLoader(false);
        setISInitialData(true);
        dispatch(setLoadingPage(false));

        preserveScrollPosition("#react-select-2-listbox");
        preserveScrollPosition("#react-select-3-listbox");
      } catch (error) {
        console.log(error);
      }
    };

    getCustomerDetailList();
  }, [
    searchKeyword,
    pageLimit,
    currentPage,
    sortOrder,
    customer_code,
    sortKey,
    customer_code,
    costCenterName,
    dateFrom,
    dateTo,
  ]);

    useEffect(() => {
      getCostCenter();
    }, [customer_code]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected + 1);
    setListLoader(true);
  };

  const renderSortIcon = (key) => {
    if (sortKey !== key) return <img src={DescIcon} alt="Descending" />;
    return sortOrder === -1 ? (
      <img src={DescIcon} alt="Descending" />
    ) : sortOrder === 1 ? (
      <img src={AscIcon} alt="Ascending" />
    ) : null;
  };
  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === -1 ? 1 : -1);
      setCurrentPage(1);
      setListLoader(true);
    } else {
      setSortKey(key);
      setSortOrder(1);
      setCurrentPage(1);
      setListLoader(true);
    }
  };

  function convertDateStringToMMDDYYYY(dateString) {
    // Check if the input date string is valid
    if (!dateString) {
      return "";
    }

    const parts = dateString.split("-");
    return `${parts[1]}/${parts[0]}/${parts[2]}`;
  }

    const getCostCenter = async () => {
      const resp = await axios.post(
        `${API_CALL_URL_PRIVATE}/department/departmentList`,
        {
          customer_code: parseInt(customer_code),
          limit: "100000",
          application_id:[101]
        }
      );
      setCostCenterMaster(
        resp?.data?.data?.data?.docs?.map((e) => {
          return {
            cost_center_name: e.cost_center_name,
            cost_center_number: e.cost_center_number,
          };
        })
      );
      // setISInitialData(true);
      console.log(resp);
      const DropCost = resp?.data?.data?.data?.docs?.map((e) => {
        return {
          label: e.cost_center_name,
          value: e.cost_center_number,
        };
      });
      setDropCostCenterMaster((prev) => {
        return DropCost?.length > 0
          ? [{ value: "", label: "All" }, ...DropCost]
          : [];
      });
    };


      const csvHandle = async () => {
        
        if (!validateFields()) {
          return;
        }
         setIsLoading(true);
        try {
          const paramData = {
            customer_code: customer_code,
            start_date: dateFrom ? moment(dateFrom).format("DD-MM-YYYY") : "",
            end_date: dateTo ? moment(dateTo).format("DD-MM-YYYY") : "",
            cost_center_number_arr: costCenterName.map((e) => e.value),
          };

          let fileName = `${customer_code}-cost_centers_report-${Date.now()}.xlsx`;

          const resp = await axios.post(
            `${API_CALL_URL_PRIVATE}/direct/downloadDirectData`,
            paramData,
            {
              responseType: "blob",
            }
          );

          const contentType = resp.headers["content-type"];

          if (contentType.includes("application/json")) {
            // If it's JSON, convert the Blob to JSON
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorResponse = JSON.parse(reader.result);
                const { responseData } = errorResponse;
                // setShowError(true);
                // setSucessmsg(responseData?.message);
                // setTimeout(() => {
                //   setShowError(false);
                // }, 2000);

                if (responseData && !responseData.success) {
                  console.error("Error message:", responseData.message);
                }
                // setIsLoading(false);
              } catch (error) {
                console.error("Error parsing JSON:", error);
                // setIsLoading(false);
              }
            };
            reader.readAsText(resp.data);
            setIsLoading(false);
          } else {
            const blob = resp.data;
            const text = await blob.text();

            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();

            window.URL.revokeObjectURL(url);
            link.remove();
            // setIsLoading(false);
            setIsLoading(false);
          }
        } catch (error) {
          console.error("Error downloading the CSV file: ", error);
          setIsLoading(false);
          // const errorResponse = decryptedFunction(
          //   error?.response?.data?.responseData
          // );
          // setShowError(true);
          // setSucessmsg(errorResponse?.message);
          setTimeout(() => {
            // setShowError(false);
          }, 2000);

          // setIsLoading(false);
        }
      };


      const handleMultiChange = (selectedOptions) => {
        setErrors((prev) => ({ ...prev, costCenterName: "" }));
        if (selectedOptions.length > 10) {
          Swal.fire({
            icon: "error",
            title: "Selection Limit Exceeded",
            text: "You can choose a maximum of 10 cost centers.",
            confirmButtonColor: "#d33",
          });
          return; // Stop further execution
        }

        setCostCenterName(selectedOptions);
        setListLoader(true);
      };


       const callBackhideupdate = (value, issuceess, msg) => {
         setShowupdate(value);
        //  if (issuceess) {
        //    setShowsuccess(true);
        //    setSucessmsg(msg);
        //    setTimeout(() => {
        //      setShowsuccess(false);
        //    }, 2000);
        //  }
       };


       console.log("showupdate", showupdate);
       
  return (
    <>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <h3 className="page-title">
              <a href="#" className="badge badge-dark"></a>
            </h3>
            <div className></div>
          </div>
          <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mobile-wrap mb-4">
                    <div>
                      <h4 className="card-title">RealTime Data</h4>
                    </div>
                    <div className="d-flex justify-content-between align-items-center gap-3 w-50">
                      {" "}
                      <div className="d-flex flex-column col dt-pi position-relative">
                        <h5 class="m-0 fs-6 d-flex align-items-center">
                          From Date
                          <CiCalendarDate className="fs-5 mx-2" />
                        </h5>
                        <ReactDatePicker
                          closeOnScroll={(e) => e.target === document}
                          selected={dateFrom}
                          dateFormat="MM/dd/yyyy"
                          isClearable={true}
                          maxDate={currentDate}
                          minDate={twoYearsAgo}
                          onChange={(date) => {
                            setDateFrom(date);
                            setListLoader(true);
                            setErrors((prev) => ({ ...prev, dateFrom: "" }));
                          }}

                          // onFocus={() => setIsDatePickerFocused(true)}
                          // onBlur={() => setIsDatePickerFocused(false)}
                        />
                        <div style={{ height: "20px" }}>
                          {errors.dateFrom && (
                            <p style={{ color: "red" }}>{errors.dateFrom}</p>
                          )}
                        </div>
                        {/* <span
                            style={{
                              position: "absolute",
                              right: "20px",
                              bottom: "8px",
                            }}
                          >
                            {isDatePickerFocused ? (
                              <RxCrossCircled className="fs-5" onClick={()={}} />
                            ) : (
                              <CiCalendarDate className="fs-4" />
                            )}
                          </span> */}
                      </div>
                      <div className="d-flex flex-column col dt-pi">
                        <h5 class="m-0 fs-6 d-flex align-items-center">
                          To Date
                          <CiCalendarDate className="fs-5 mx-2" />
                        </h5>
                        <div
                        //   className="ms-4"
                        >
                          <ReactDatePicker
                            closeOnScroll={(e) => e.target === document}
                            selected={dateTo}
                            dateFormat="MM/dd/yyyy"
                            isClearable={true}
                            minDate={dateFrom || twoYearsAgo}
                            maxDate={currentDate}
                            onChange={(date) => {
                              setDateTo(date);
                              setListLoader(true);
                              setErrors((prev) => ({ ...prev, dateTo: "" }));
                            }}
                          />
                          <div style={{ height: "20px" }}>
                            {errors.dateTo && (
                              <p style={{ color: "red" }}>{errors.dateTo}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className={`d-flex flex-column col`}>
                        <h5 class="m-0 fs-6 ">Cost Center Name</h5>
                        <div
                        //   className="ms-4"
                        >
                          {/* <Select
                            isSearchable="true"
                            options={dropCostCenterMaster}
                            className="custom-select"
                            onChange={(e) => {
                              setCostCenterName(e.value);
                              setListLoader(true);
                            }}
                          /> */}

                          <MultiSelect
                            key="example_id"
                            placeholder="Select..."
                            options={dropCostCenterMaster.filter(
                              (option) => option.value !== ""
                            )}
                            onChange={handleMultiChange}
                            // onChange={(e) => {
                            //   setCostCenterName(e);
                            //   setListLoader(true);
                            // }}
                            value={costCenterName}
                            isDirectData={true}
                            isSelectAll={true}
                            menuPlacement={"bottom"}
                            theme={theme.theme === "LIGHT"}
                          />
                        </div>
                        <div style={{ height: "20px" }}>
                          {errors.costCenterName && (
                            <p style={{ color: "red" }}>
                              {errors.costCenterName}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div>
                      {/* <Link
                        className="boxlink"
                        to="/admin/direct-data/import-direct-data"
                      >
                        {" "}
                        <button type="button" class="btn btn-success">
                          Import File
                        </button>
                      </Link> */}
                      <button
                        style={{ marginRight: "1.2rem" }}
                        type="button"
                        onClick={csvHandle}
                        disabled={isEmpty(customerData)}
                        className={`btn btn-success ${
                          isEmpty(customerData) ? "not-allowedx" : ""
                        }`}
                      >
                        Download Data
                      </button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mobile-wrap">
                    <div class="dataTables_length" id="example_length">
                      <label>
                        Show &nbsp;
                        <select
                          name="example_length"
                          aria-controls="example"
                          class=""
                          value={pageLimit}
                          onChange={(e) => {
                            setPageLimit(e.target.value);
                            setListLoader(true);
                          }}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>{" "}
                        &nbsp;entries
                      </label>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div>
                        {/* <button
                          style={{ marginRight: "1.2rem" }}
                          type="button"
                          onClick={csvHandle}
                          disabled={isEmpty(customerData)}
                          className={`btn btn-success ${
                            isEmpty(customerData) ? "not-allowedx" : ""
                          }`}
                        >
                          Download Data
                        </button> */}
                      </div>
                      <div>
                        <form
                          onSubmit={(e) => {
                            e.preventDefault(); // Prevent the default form submission behavior
                            if (searchKeyword !== searchTempKeyword) {
                              flushSync(() => {
                                setSearchActive(true);
                                setSortKey("");
                              });
                              setListLoader(true);
                              setSearchKeyword(searchTempKeyword);
                            }
                          }}
                        >
                          <div
                            id="example_filter"
                            class="dataTables_filter d-flex align-items-center justify-content-center "
                          >
                            <label>
                              Search: &nbsp;
                              <input
                                type="text"
                                class=""
                                placeholder=""
                                aria-controls="example"
                                onChange={(e) => {
                                  setSearchTempKeyword(e.target.value);
                                  if (e.target.value === "") {
                                    setListLoader(true);
                                    setSearchKeyword("");
                                  }
                                }}
                                // onKeyDown={(e) => {
                                //   if (e.key === "Enter") {
                                //     setSearchKeyword(e.target.value);
                                //   }
                                // }}
                              />
                            </label>

                            <div
                              style={{
                                border: "1px solid #aaa",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "9px",
                                marginBottom: "7px",
                                cursor: "pointer",
                                marginTop: "-1px",
                                marginLeft: "-1px",
                              }}
                              onClick={() => {
                                if (searchKeyword !== searchTempKeyword) {
                                  flushSync(() => {
                                    setSearchActive(true);
                                    setSortKey("");
                                  });
                                  setListLoader(true);
                                  setSearchKeyword(searchTempKeyword);
                                }
                              }}
                            >
                              <i class="ph ph-magnifying-glass"></i>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="table-responsive">
                      <table className="table filter-table">
                        <thead>
                          <tr>
                            <th>No.</th>

                            <th
                              onClick={() => {
                                handleSort("cost_center_number");
                              }}
                            >
                              Cost Center
                              <span className="ms-1 bright">
                                {renderSortIcon("cost_center_number")}
                              </span>
                            </th>

                            <th
                              onClick={() => {
                                handleSort("shift_date");
                              }}
                            >
                              Shift Date
                              <span className="ms-1 bright">
                                {renderSortIcon("shift_date")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("shift_time");
                              }}
                            >
                              Shift Time
                              <span className="ms-1 bright">
                                {renderSortIcon("shift_time")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("filter_date");
                              }}
                            >
                              Filter Date
                              <span className="ms-1 bright">
                                {renderSortIcon("filter_date")}
                              </span>
                            </th>

                            <th
                              onClick={() => {
                                handleSort("updatedAt");
                              }}
                            >
                              Updated At
                              <span className="ms-1 bright">
                                {renderSortIcon("updatedAt")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("createdAt");
                              }}
                            >
                              Created At
                              <span className="ms-1 bright">
                                {renderSortIcon("createdAt")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("portal_users.employee_name");
                              }}
                            >
                              Update By
                              <span className="ms-1 bright">
                                {renderSortIcon("portal_users.employee_name")}
                              </span>
                            </th>
                            <th>Action</th>

                            {/* <th 
                          onClick={() => {
                            setSortKey("status");
                            setSortOrder(sortOrder === 1 ? -1 : 1);
                          }}
                        >
                          Statusgit add
                        </th> */}
                            {/* <th></th> */}
                          </tr>
                        </thead>
                        {isInitialData && !loading_page && !listLoader ? (
                          <>
                            {customerData?.docs?.length > 0 ? (
                              <tbody>
                                {customerData?.docs?.map((Ele, i) => {
                                  return (
                                    <tr key={Ele._id}>
                                      <td>{i + pageCounter}</td>
                                      <td>{`${Ele?.cost_center_number} - ${Ele?.cost_center_name}`}</td>
                                      <td>
                                        {convertDateStringToMMDDYYYY(
                                          Ele?.shift_date
                                        )}
                                      </td>
                                      <td>{Ele?.shift_time}</td>
                                      <td>{Ele?.filter_date}</td>

                                      <td>{getDate(Ele?.updatedAt)}</td>
                                      <td>{getDate(Ele?.createdAt)}</td>
                                      <td>{Ele?.updated_by_name}</td>
                                      <td>
                                        <label className="edit">
                                          <CiShare1
                                            size={20}
                                            onClick={() => {
                                                setShowupdate({
                                                  state: true,
                                                  shiftData: Ele,
                                                });
                                            }}
                                          />
                                        </label>
                                      </td>

                                      {/* <td>
                                        <label className="edit">
                                          <Link
                                            className="boxlink"
                                            to={`/admin/facility/edit-facility/${Ele?._id}`}
                                          >
                                            <img
                                              src={Ico1}
                                              className="w-a"
                                              alt="icon"
                                            />
                                          </Link>
                                        </label>
                                      </td> */}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan="9">
                                    <div
                                      className="d-flex justify-content-center align-items-center"
                                      style={{ height: "200px" }}
                                    >
                                      <p class="text-secondary display-6">
                                        Oops! Data Not found
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </>
                        ) : (
                          <>
                            <tbody>
                              <tr>
                                <td colSpan="9">
                                  <div
                                    className="d-flex align-items-center justify-content-center w-100"
                                    style={{ height: "400px" }}
                                  >
                                    <span
                                      class="loader"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                      }}
                                    ></span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </>
                        )}
                      </table>
                    </div>

                    {isInitialData && !loading_page && !listLoader ? (
                      <>
                        <div className="d-flex justify-content-between">
                          <div
                            class="dataTables_info"
                            id="example_info"
                            role="status"
                            aria-live="polite"
                          >
                            Showing {pageCounter} to{" "}
                            {Math.min(
                              pageCounter + pageLimit - 1,
                              customerData.totalDocs
                            )}{" "}
                            of total {customerData?.totalDocs} entries
                          </div>
                          <div
                            class="dataTables_paginate paging_simple_numbers"
                            id="example_paginate"
                          >
                            <span>
                              <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={customerData?.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                previousLinkClassName={"paginationLink"}
                                nextLinkClassName={"paginationLink"}
                                disabledClassName={"paginationDisabled"}
                                activeClassName={"paginationActive"}
                                forcePage={currentPage - 1}
                              />
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <IntervalDetail
        isShow={showupdate.state}
        shiftData={showupdate.shiftData}
        cost_center_name={showupdate?.shiftData?.cost_center_name}
        numbers={"test"}
        previousShiftData={[]}
        getprevAndCurrentShift={[]}
        gridData={[]}
        callbackfunc={callBackhideupdate}
        // reloaddata={addupdatereportnotecallback}
        data_id={showupdate?.shiftData?._id}
        cost_center_number={showupdate?.shiftData?.cost_center_number}
        getPreAndCurr={[]}
        acuityNurse={"test"}
        formContent={[]}
        onHide={() => {
          setShowupdate({ state: false, shiftData: null });
        }}
      />
      {isLoading && <Overlay />}
    </>
  );
}

export default DirectData;
